import Link from "next/link";

interface DsButtonProps {
  href: string;
  label: string;
  variant: "primary" | "blue" | "ghost" | "ghost-inverse" | "white";
  className?: string;
  target?: string;
  rel?: string;
}

export default function DsButton({
  href,
  label,
  variant,
  className,
  target,
  rel,
}: DsButtonProps) {
  return (
    <Link href={href} className={`btn btn-${variant} ${className ?? ""}`.trim()} target={target} rel={rel}>
      {label}
    </Link>
  );
}
